export default [
    {
        path: '/local',
        name: 'Local',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/local/LocalIndex.vue'),
        },
    },
    {
        path: '/local/create',
        name: 'LocalCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/local/LocalCreate.vue'),
        },
    },
    {
        path: '/local/:id/edit',
        name: 'LocalEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/local/LocalEdit.vue'),
        },
    },
];
